function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5 5.5L5.75 11.25C3.67893 13.3211 3.67893 16.6789 5.75 18.75V18.75C7.82107 20.8211 11.1789 20.8211 13.25 18.75L20 12C21.3807 10.6193 21.3807 8.38071 20 7V7C18.6193 5.61929 16.3807 5.61929 15 7L8.25 13.75C7.55965 14.4404 7.55964 15.5596 8.25 16.25V16.25C8.94036 16.9404 10.0596 16.9404 10.75 16.25L16.5 10.5",
  stroke: "black",
  strokeWidth: 2
});

var SvgAttachment = function SvgAttachment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAttachment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/attachment.02ce51bb.svg";
export { ForwardRef as ReactComponent };